import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Icon } from 'design-system-web';
import { ICON_SET_FONTAWESOME } from 'lane-shared/helpers/constants/icons';

import styles from './InspectionTemplateCustomizeSectionCard.scss';

type Props = {
  sectionId: string;
  reorderEnabled: boolean;
  children: (dragHandle: React.ReactNode) => React.ReactNode;
};

export function SortableSectionCardWrapper({
  sectionId,
  reorderEnabled,
  children,
}: Props) {
  const { t } = useTranslation();
  const disabled = !reorderEnabled;

  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: sectionId, disabled });

  const style: React.CSSProperties = {
    transform: disabled ? undefined : CSS.Transform.toString(transform),
    transition,
  };

  const dragHandle = reorderEnabled ? (
    <button
      type="button"
      ref={setActivatorNodeRef}
      className={classNames(styles.sectionDragHandle)}
      aria-label={t(
        'web.admin.inspections.templateCustomize.dragHandleAriaLabel'
      )}
      {...attributes}
      {...listeners}
    >
      <Icon name="grip-vertical" set={ICON_SET_FONTAWESOME} type="far" />
    </button>
  ) : null;

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={classNames(styles.sortableSectionWrapper, {
        [styles.sortableSectionWrapperDragging]: isDragging,
      })}
    >
      {children(dragHandle)}
    </div>
  );
}
